export const MAESTRO = 'maestro'
export const CATALOG = 'catalog'
export const LOADING = 'loading'

export const fieldsDataCatalogo = Object.freeze([
    {
        id: 'marca',
        placeHolder: 'Marca',
        dataField: 'brand_id'
    },
    {
        id: 'modelo',
        placeHolder: 'Modelo',
        dataField: 'model_id'
    },
    {
        id: 'version',
        placeHolder: 'Versión',
        dataField: 'version_id'
    }
])

export const fieldsDataGeneralList = Object.freeze([
    {
        id: 'marca',
        placeHolder: 'Marca',
        dataField: 'brand_id'
    },
    {
        id: 'modelo',
        placeHolder: 'Modelo',
        dataField: 'model_id'
    },
    {
        id: 'anio',
        placeHolder: 'Año',
        dataField: 'anio_id'
    },
    {
        id: 'version',
        placeHolder: 'Versión',
        dataField: 'version_id'
    }
])

export const SPECIFICATIONS = {
    ALL: 'todas',
    DIFFERENCES: 'diferencias',
    COINCIDENCES: 'coincidencias',
}

export const CATEGORIES = {
    BEST_FINANCING: 'financiacion-destacada',
    RELEVANT_ATTRIBUTES: 'atributos-relevantes',
    TECHNICAL_SPECS: 'technical_specs',
    GENERAL: 'general',
    SECURITY: 'seguridad',
    CONFORT: 'confort',
    EXTERNAL: 'exterior',
    DRIVING: 'ayudasConduccion',
}

export const fieldsCategories = [
    {
        label: '',
        options: [
            { value: CATEGORIES.BEST_FINANCING, label: 'Financiación destacada' },
            { value: CATEGORIES.RELEVANT_ATTRIBUTES, label: 'Atributos relevantes' },
        ],
    },
    {
        label: 'Especificaciones técnicas',
        options: [
            { value: CATEGORIES.GENERAL, label: 'General' },
            { value: CATEGORIES.SECURITY, label: 'Seguridad' },
            { value: CATEGORIES.CONFORT, label: 'Confort' },
            { value: CATEGORIES.EXTERNAL, label: 'Exterior' },
            { value: CATEGORIES.DRIVING, label: 'Ayudas a la conducción' },
        ],
    },
]

export const fieldsSpecifications = [
    {
        value: SPECIFICATIONS.ALL,
        label: 'Todas',
        description: 'Se muestran todas las especificaciones de los autos'
    },
    {
        value: SPECIFICATIONS.DIFFERENCES,
        label: 'Diferencias',
        description: 'Se muestran únicamente las especificaciones que sean diferentes entre los autos'
    },
    {
        value: SPECIFICATIONS.COINCIDENCES,
        label: 'Coincidencias',
        description: 'Se muestran únicamente las especificaciones que sean iguales entre los autos'
    },
]
